import ContainerHeader from "Components/Atoms/Containers/ContainerHeader/ContainerHeader";
import Paper from "Components/Atoms/Containers/Paper/Paper";
import EditButtons from "Components/Atoms/EditButtons/EditButtons";
import RowItem from "Components/Atoms/Row/RowItem";
import RowItemInfo from "Components/Atoms/Row/RowItemInfo";
import RowItemTitle from "Components/Atoms/Row/RowItemTitle";
import DisplayName from "Components/Molecules/DisplayName/DisplayName";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { StoreState } from "Store/Reducers";
import { patchEntity } from "Store/Settings/Entities/Actions";
import { EntityId } from "Store/Settings/Entities/PropTypes";
import { getEntityById } from "Store/Settings/Entities/Selectors";
import { fetchFields } from "Store/Settings/Fields/Actions";

const GeneralSettings = ({ entity, ...props}: GeneralSettingsProps) => {
    const [state, setState] = useState({
        isEdit: false
    });

    const [data, setData] = useState({
        name_fields: entity?.name_fields
    });

    useEffect(() => {
        props.fetchFields();
    }, []);

    const handleSave = () => props.patchEntity(entity.id, {
        name_fields: data.name_fields
    });
    
    return <>
        <ContainerHeader title={'Algemeen'}>
            <EditButtons
                onEdit={(value) => setState({...state, isEdit: value})}
                onSave={handleSave}
                onCancel={() => {}}
            />
        </ContainerHeader>
        <Paper>
            <RowItem>
                <RowItemTitle>Weergave naam</RowItemTitle>
                <RowItemInfo>
                    <DisplayName
                        entity={entity}
                        value={data?.name_fields}
                        isEdit={state.isEdit}
                        onChange={(value: any) => setData({...data, name_fields: value})}
                    />
                </RowItemInfo>
            </RowItem>
        </Paper>
    </>;
}

interface Props {
    id: EntityId 
}

const mapState = (state: StoreState, props: Props) => ({
    entity: getEntityById(state, props.id)
})

const mapDispatch = {
    fetchFields,
    patchEntity
}

type GeneralSettingsProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(GeneralSettings);